import ApplicationSharing from './ApplicationSharing';

export default ApplicationSharing;
